import React from 'react';
import { Popup } from 'components/common/popup/Popup';
import { TemplateFormComponent } from 'components/common/form/layout/ReactHookFormController';
import useBundleTranslation from 'i18n';
import useCustomSimplifiedForm from 'components/common/form/hooks/useCustomSimplifiedForm';
import { FormComponentValue } from 'components/common/form/layout/control';
import { useConfigConstantValue } from 'hooks/useConfigConstant';

export interface ShareWithPopupProps {
    //ToDo settingsUrl  + settingsUrl for checkBoxProps
    //urlParams: UrlParams;
    //settingsUrl: string;
    data: any;
    onClose: () => void;
    onConfirm: (selectedValues: any) => void;
    linkData: {
        elementId: number;
        segmentValueId: number;
    };
}

export default function ShareWithPopup(props: ShareWithPopupProps) {
    const { data, linkData, onClose = () => {}, onConfirm = () => {} } = props;
    const { t } = useBundleTranslation();
    const checkBoxListName = 'share_selected_emails_users';
    const hideUserEmail = useConfigConstantValue('HIDE_USER_EMAIL_ADDRESSES');

    const popupSettings = {
        title: t('share_with'),
        textOK: t('add'),
    };

    const formActions = useCustomSimplifiedForm({
        checkBoxListName: JSON.stringify(['119', '84']),
    });

    const handleApply = () => {
        let result: Array<FormComponentValue> = [];
        const register = formActions.form.getElementValuesRegister(checkBoxListName);
        if (register) {
            const selectedOption: Array<FormComponentValue> = register.componentStatePropsRef?.current?.selectedOption;
            if (selectedOption) {
                result = selectedOption;
            }
        }
        onConfirm(result);
    };

    return (
        <Popup onConfirm={handleApply} settings={popupSettings} open={true} onHide={onClose}>
            <TemplateFormComponent
                elementProps={formActions}
                component={'CheckBoxList'}
                name={checkBoxListName}
                props={{
                    async: true,
                    dataUrl: '/data/notification/favorites/get-users-data?elementId=:elementId&segmentId=:segmentId',
                    dataPageSize: 100,
                    settingsUrl: '/data/notification/favorites/users?elementId=:elementId&segmentId=:segmentId',
                    height: 400,
                    showCounter: false,
                    defaultRowHeight: hideUserEmail ? 32 : 50,
                    urlParams: {
                        elementId: linkData.elementId,
                        segmentId: linkData.segmentValueId,
                    },
                }}
            />
        </Popup>
    );
}
